// import { createSlice } from "@reduxjs/toolkit";
// import { addProFormaInvoiceForm ,getProFormaInvoiceForm, getProFormaDataList} from "./ThunkAction";
// import { ProFormaInvoce } from "./Types";

// const initialState: ProFormaInvoce = {
//   detail: null,
//   list: [],  
//   loading: false,
//   message: null,
//   error: null,
// };

// const proFormaStateSlice = createSlice({
//   name: "proFormaState",
//   initialState,
//   reducers: {
//     clearProFormaState: (state) => {
//       state.detail = null;
//       state.list = null;
//       state.loading = false;
//       state.message = null;
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     // ✅ Add recharge
//     builder
//       .addCase(addProFormaInvoiceForm.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//         state.message = null;
//       })
//       .addCase(addProFormaInvoiceForm.fulfilled, (state, action) => {
//         state.loading = false;
//         state.detail = action.payload?.data || null;
//         state.message = action.payload?.message || null;
//       })
//       .addCase(addProFormaInvoiceForm.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload?.message || "Something went wrong";
//       });

//     // ✅ Get recharge list
//     builder
//       .addCase(getProFormaInvoiceForm.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//         state.message = null;
//       })
//       .addCase(getProFormaInvoiceForm.fulfilled, (state, action) => {
//         state.loading = false;
//         state.list = action.payload?.data || null;
//         state.message = action.payload?.message || null;
//       })
//       .addCase(getProFormaInvoiceForm.rejected, (state, action) => {
//         state.loading = false;
//         // @ts-expect-error
//         state.error = action.payload?.message || "Something went wrong";
//       });
//   },
// });

// export const { clearProFormaState } = proFormaStateSlice.actions;
// export default proFormaStateSlice.reducer;


import { createSlice } from "@reduxjs/toolkit";
import { addProFormaInvoiceForm, getProFormaInvoiceForm,  getProFormaDataList } from "./ThunkAction";
import { ProFormaInvoce } from "./Types";

const initialState: ProFormaInvoce = {
  detail: null,
  list: [], // for getProFormaInvoiceForm
  dataList: [], // ✅ for getProFormaDataList
  loadingList: false, // ✅ separate loading for list
  loadingDataList: false, // ✅ separate loading for dataList
  message: null,
  error: null,
  loading: false
};

const proFormaStateSlice = createSlice({
  name: "proFormaState",
  initialState,
  reducers: {
    clearProFormaState: (state) => {
      state.detail = null;
      state.list = [];
      state.dataList = [];
      state.loadingList = false;
      state.loadingDataList = false;
      state.message = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // ✅ Add proforma invoice
    builder
      .addCase(addProFormaInvoiceForm.pending, (state) => {
        state.loadingList = true;
        state.error = null;
        state.message = null;
      })
      .addCase(addProFormaInvoiceForm.fulfilled, (state, action) => {
        state.loadingList = false;
        state.detail = action.payload?.data || null;
        state.message = action.payload?.message || null;
      })
      .addCase(addProFormaInvoiceForm.rejected, (state, action) => {
        state.loadingList = false;
        state.error = action.payload?.message || "Something went wrong";
      });

    // ✅ Get ProForma Invoice List
    builder
      .addCase(getProFormaInvoiceForm.pending, (state) => {
        state.loadingList = true;
        state.error = null;
      })
      .addCase(getProFormaInvoiceForm.fulfilled, (state, action) => {
        state.loadingList = false;
        state.list = action.payload?.data || [];
        state.message = action.payload?.message || null;
      })
      .addCase(getProFormaInvoiceForm.rejected, (state, action) => {
        state.loadingList = false;
        // @ts-expect-error
        state.error = action.payload?.message || "Something went wrong";
      });

    // ✅ Get ProForma Data List (new API)
    builder
      .addCase(getProFormaDataList.pending, (state) => {
        state.loadingDataList = true;
        state.error = null;
      })
      .addCase(getProFormaDataList.fulfilled, (state, action) => {
        state.loadingDataList = false;
        state.dataList = action.payload?.data || [];
        state.message = action.payload?.message || null;
      })
      .addCase(getProFormaDataList.rejected, (state, action) => {
        state.loadingDataList = false;
        // @ts-expect-error
        state.error = action.payload?.message || "Something went wrong";
      });
  },
});

export const { clearProFormaState } = proFormaStateSlice.actions;
export default proFormaStateSlice.reducer;
